module.exports = __webpack_public_path__ + "media/images/mobile/solutions/2-2cc11363dd5e7a1cca97e23953e80f86.png";